export default __webpack_public_path__ + "static/las_puertas_de_mazatlan_logo_yellow-5318ec0f68d1bbded5043c31134a628f.svg";